import React from "react";
import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";
import { BsEnvelopeAtFill, BsTelephoneFill } from "react-icons/bs";
import { MdLocationPin } from "react-icons/md";
import { FaGavel } from "react-icons/fa";
import { Link } from "react-router-dom";

export const ContactLocationSection = () => {
  return (
    <section className="location-section">
      <div className="info-container">
        <h1>VH BuildUp!</h1>
        <br />
        <div className="details">
          <p className="contact-link">
            <MdLocationPin size={20} /> Chrysantenstraat 93 - 2610 Wilrijk
          </p>
          <Link className="contact-link" to={"tel:+32 473 40 35 96"}>
            <BsTelephoneFill size={20} />
            <p>0473 40 35 96</p>
          </Link>
          <Link className="contact-link" to={"mailto:info@vhbuildup.be"}>
            <BsEnvelopeAtFill size={20} />
            <p>info@vhbuildup.be</p>
          </Link>
          <p className="contact-link">
            <FaGavel size={20} /> BTW BE 0668.703.746
          </p>
        </div>
      </div>
      <div className="location-container">
        <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
          <Map
            defaultZoom={15}
            defaultCenter={{ lat: 51.17979944524284, lng: 4.381106115402325 }}
          >
            <Marker
              position={{ lat: 51.17979944524284, lng: 4.381106115402325 }}
            />
          </Map>
        </APIProvider>
      </div>
    </section>
  );
};
